import React, { useContext } from "react";
import { AppContext } from "../../App";
import { exchanger } from "../../rbac-consts";
import Can from "../can/Can";
import ExchangeHistoryDetailsContainer from "./master/history/ExchangeHistoryDetailsContainer";
import AdminExchangeHistoryDetailsContainer from "./admin/history/ExchangeHistoryDetailsContainer";

const ExchangeDetails = ({ match }) => {
  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={exchanger.MASTER}
        yes={() => (
          <ExchangeHistoryDetailsContainer match={match}/>
        )}
      />
      <Can
        role={user.roles}
        perform={exchanger.ADMIN}
        yes={() => (
          <AdminExchangeHistoryDetailsContainer match={match}/>
        )}
      />
    </>
  );
};

export default ExchangeDetails;